import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
    NgbDatepickerModule,
    NgbPopoverModule,
    NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { AmazingTimePickerModule } from './atp-library/atp-time-picker.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { CollapsibleDividerComponent } from './components/collapsible-divider/collapsible-divider.component';
import { ControlGroupComponent } from './components/control-group/control-group.component';
import { ControlRefDirective } from './directives/control-ref.directive';
import { PhoneExtDirective } from './directives/masking/phone-ext.directive';
import { SvgModule } from './svg/svg.module';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { DualListBoxComponent } from './components/dual-list-box/dual-list-box.component';
import { RadioButtonListComponent } from './components/radio-button-list/radio-button-list.component';
import { TouchRadioButtonListComponent } from './components/touch-radio-button-list/touch-radio-button-list.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FixedButtonsComponent } from './components/fixed-buttons/fixed-buttons.component';
import { NumericDirective } from './directives/masking/numeric.directive';
import { CurrencyService } from './directives/masking/currency.service';
import { CurrencyDirective } from './directives/masking/currency.directive';
import { PercentageDirective } from './directives/masking/percentage.directive';
import { PercentageService } from './directives/masking/percentage.service';
import { SubmitUrlDirective } from './directives/submit-url.directive';
import { BackButtonDirective } from './directives/back-button.directive';
import { ShowHidePasswordComponent } from './components/show-hide-password/show-hide-password.component';
import { PcgSelectComponent } from './components/pcg-select-component/select.component';
import { TextEditorComponent } from './text-editor/text-editor.component';

@NgModule({
    declarations: [
        ControlGroupComponent,
        ControlRefDirective,
        CollapsibleDividerComponent,
        PhoneExtDirective,
        PercentageDirective,
        DateRangeComponent,
        DualListBoxComponent,
        RadioButtonListComponent,
        TouchRadioButtonListComponent,
        FileUploadComponent,
        FixedButtonsComponent,
        NumericDirective,
        CurrencyDirective,
        SubmitUrlDirective,
        BackButtonDirective,
        ShowHidePasswordComponent,
        PcgSelectComponent,
        TextEditorComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        SvgModule,
        NgbDatepickerModule,
        AmazingTimePickerModule,
        AngularDualListBoxModule,
        NgbPopoverModule,
        NgSelectModule,
        NgbTooltipModule,
        RouterModule,
        FontAwesomeModule,
    ],
    exports: [
        ControlGroupComponent,
        ControlRefDirective,
        CollapsibleDividerComponent,
        PhoneExtDirective,
        NumericDirective,
        CurrencyDirective,
        PercentageDirective,
        BackButtonDirective,
        SvgModule,
        DateRangeComponent,
        DualListBoxComponent,
        RadioButtonListComponent,
        TouchRadioButtonListComponent,
        FileUploadComponent,
        FixedButtonsComponent,
        SubmitUrlDirective,
        PcgSelectComponent,
        ShowHidePasswordComponent,
        FontAwesomeModule,
        TextEditorComponent,
    ],
    providers: [CurrencyService, PercentageService],
})
export class FormElementsModule {}
